export default __webpack_public_path__ + "static/media/Sash of a Thousand Blossoms.59384166.jpg";